<template>
  <FormInput :dati='info'
               :formlabel="label"
               :stilestruttura="style"
               :idform="idform"
               :action="action"
               :recaptcha="recaptcha"
               @selectChanged="handleSelectChange"
               ref="input">
    </FormInput>

	<div class="text-right">
    <button @click="riapriTicket" class="p-button p-component p-button-success" v-if="is_completato && !hide_riapri" :disabled="isRiaprendo">
			<span class="p-button-label">{{ $root.trans.riapri_ticket }}</span>
    </button>
		<button @click="checkOre" class="p-button p-component p-button-success">
			<span class="p-button-label">{{ bottonesalva }}</span>
		</button>
	</div>
    <ConfirmDialog></ConfirmDialog>

</template>

<script>

import FormInput from './FormInput.vue';
import  ConfirmDialog  from 'primevue/confirmdialog';


export default {
  name: "InnerThreadForm",
  components: {
    FormInput,
    ConfirmDialog

  },
  props: [
    'dati',
    'struttura',
    'azione',
    'annulla',
    'stilestruttura',
    'id',
    'recaptcha',
    'bottonesalva',
    'bottonesalvacontinua',
    'bottoneannulla',
    'oretotali',
    'is_completato',
    'linkriapertura',
    'hide_riapri'
  ],
  data() {
    return {
      cancel: this.annulla,
      action: this.azione,
      info: JSON.parse(this.dati),
      label: JSON.parse(this.struttura),
      style: this.stilestruttura,
      errors: {},
      imginput: false,
      idform: this.id,
      isRiaprendo: false,
    };
  },
  beforeMount() {
    if (typeof this.id == "undefined") {
      this.idform = 'maschera';
    } else {
      this.idform = this.id;
    }

  },
  mounted() {
    document.addEventListener('formChanged', function(e){
      this.label = e.detail.newStruttura;
    });

  },
  methods: {
    async submitForm(){
      this.$refs.input.checkForm(0)
    },
    async riapriTicket(){
      if (this.isRiaprendo) return;
      try{
        // prima controllo se il form è compilato correttamente
        const hasErrors = await this.$refs.input.checkForm(3);
        console.log(hasErrors)
        //se non ci sono errori procedo prima con la clonazione del ticket
        if(!hasErrors){
          this.isRiaprendo = true;
          axios.post(this.linkriapertura)
            .then((response) =>{
               if (response.data.success){

                 this.$toast.add({
                      severity: 'success',
                      summary: this.$root.trans.success_form,
                      detail: this.$root.trans.salvataggio_success,
                      life: 3000
                    });
                    // a questo punto aggiorno l'id del ticket nei data
                    // dopo di che salvo il form
                    this.info.ticketing_id = response.data.ticketing_id;
                    this.info.ticketingstato_id = response.data.in_lavorazione_id;
                    this.$refs.input.sendForm(0);

               }else{
                this.isRiaprendo = false;
                if (response.data.message != null) {
                    this.$toast.add({
                      severity: 'errors',
                      summary: this.$root.trans.errors_form,
                      detail: this.$root.trans[response.data.message],
                      life: 5000
                    });
                  } else {
                    this.$toast.add({
                      severity: 'errors',
                      summary: this.$root.trans.errors_form,
                      detail: this.$root.trans.salvataggio_errato,
                      life: 3000
                    });
                  }
               }
            })
        }
      }catch(error){
        this.isRiaprendo = false;
        if (error.response && error.response.status === 401) {
          this.$toast.add({
            severity: 'errors',
            summary: this.$root.trans.errors_form,
            detail: this.$root.trans.salvataggio_errato,
            life: 3000
          });
        }
      }
    },
    handleSelectChange(e,d){
        console.log(d);
        console.log(this.info.malware_confermato)
        console.log(this.info)
      if(d == 'malware_confermato'){
        const newStruttura = {...this.label};
        newStruttura['malware_tipo'][1] =  this.info.malware_confermato == 4 ? 'checkbox-multipla' : 'hidden';
        this.label = newStruttura
          console.log(newStruttura)
      }
    },
    checkOre() {
      const ore = this.oretotali + this.info['ore'];
      if(this.info['ticketingstato_id'] == 5 && ore == 0){
        this.$confirm.require({
          message: this.$root.trans.conferma_ticket_zero_ore,
          header: this.$root.trans.conferma_ticket_zero_ore_titolo,
          rejectProps:{
              label: this.$root.trans.reject
          },
          acceptProps:{
              label: this.$root.trans.accept
          },
          accept: ()=>{
              this.$refs.input.checkForm(0)

          },
          reject: ()=>{

          }
      })
      }else{
        this.$refs.input.checkForm(0)
      }
    }
  }
}
</script>

<style scoped>

</style>
